import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserService } from '../assabil-kernel/services/user-service';
import { ConfigService } from '../tools/services/config.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(
        protected userService   : UserService,
        protected configService : ConfigService){

    }

    intercept(req: HttpRequest<any>,
              next: HttpHandler): Observable<HttpEvent<any>> {

        if ( (this.userService.userInfo) && (req.url.startsWith(this.configService.config.serverUrl))) {
            let idToken : string = "Bearer " + this.userService.userInfo.token;
            const cloned = req.clone({
                headers: req.headers.set("Authorization", idToken)
            });

            return next.handle(cloned);
        }
        else {
            return next.handle(req);
        }
    }
}